import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ChevronLeft, Bell, Smartphone } from 'lucide-react';

export const NotificationsSettingsPage = () => {
    const navigate = useNavigate();

    return (
        <main className="flex-1 w-full flex flex-col bg-transparent">
            {/* Header */}
            <div className="sticky top-0 bg-[#0a0a0a]/90 backdrop-blur-md z-40 border-b border-[#1a1a1a] flex items-center h-[60px] px-4">
                <button onClick={() => navigate('/settings')} className="sm:hidden w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors mr-2">
                    <ChevronLeft size={24} className="text-white" />
                </button>
                <h1 className="text-xl font-bold text-white">Notifications</h1>
            </div>

            <div className="flex-1 overflow-y-auto p-4 sm:p-6 pb-20 sm:pb-0">
                <div className="bg-[#111] border border-[#222] rounded-xl overflow-hidden">
                    <button 
                        onClick={() => navigate('/settings/notifications/push')}
                        className="w-full p-4 flex items-center justify-between hover:bg-[#1a1a1a] transition-colors border-b border-[#222]"
                    >
                        <div className="flex items-center">
                            <div className="w-10 h-10 rounded-full bg-[#0BD9E5]/10 flex items-center justify-center mr-4">
                                <Bell size={20} className="text-[#0BD9E5]" />
                            </div>
                            <div className="text-left">
                                <h3 className="text-white font-bold text-[16px]">Push Notifications</h3>
                                <p className="text-gray-400 text-[13px] mt-0.5 leading-tight">
                                    Manage alerts sent to your device
                                </p>
                            </div>
                        </div>
                        <ArrowLeft size={16} className="text-gray-500 rotate-180" />
                    </button>
                    
                    <button 
                        onClick={() => navigate('/settings/notifications/in-app')}
                        className="w-full p-4 flex items-center justify-between hover:bg-[#1a1a1a] transition-colors"
                    >
                        <div className="flex items-center">
                            <div className="w-10 h-10 rounded-full bg-[#BD00FF]/10 flex items-center justify-center mr-4">
                                <Smartphone size={20} className="text-[#BD00FF]" />
                            </div>
                            <div className="text-left">
                                <h3 className="text-white font-bold text-[16px]">In-App Notifications</h3>
                                <p className="text-gray-400 text-[13px] mt-0.5 leading-tight">
                                    Manage banners shown while using Spark
                                </p>
                            </div>
                        </div>
                        <ArrowLeft size={16} className="text-gray-500 rotate-180" />
                    </button>
                </div>
            </div>
        </main>
    );
};

export default NotificationsSettingsPage;
